import { render, staticRenderFns } from "./ai_settings.vue?vue&type=template&id=20fbadae&scoped=true&"
import script from "./ai_settings.vue?vue&type=script&lang=js&"
export * from "./ai_settings.vue?vue&type=script&lang=js&"
import style0 from "./ai_settings.vue?vue&type=style&index=0&id=20fbadae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20fbadae",
  null
  
)

export default component.exports